import type { RequestProductsActionPayloadData } from 'src/redux/products/types';
import type { BrowseDataAPIResponseBody } from 'src/services/browse-data-api/types/BrowseDataAPIResponseBody';

export const adaptBrowseDataAPIBodyToReduxActionPayload = (
  browseServiceProductsData: BrowseDataAPIResponseBody,
): RequestProductsActionPayloadData => {
  const {
    attributionToken,
    category,
    currencyCode,
    products,
    perPage,
    currentPage,
    totalPages,
    filters,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    term,
    navigation,
    partner,
    zeroExactResults,
    pinnedResultCount,
    providerMetadata,
  } = browseServiceProductsData;

  return {
    category,
    currencyCode,
    products,
    perPage,
    filters,
    currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    term,
    navigation,
    partner,
    providerAttributionToken: attributionToken || null,
    zeroExactResults,
    pinnedResultCount,
    providerMetadata,
  };
};
